/**
 * Boot gate. `SHELL-001`, `SHELL-004`, `PROG-020`.
 *
 * Sits between `main.tsx`'s error boundary and `App`: the save document is
 * read once here, and nothing below this component -- `App`, every route it
 * matches -- renders until that read has resolved. `App` itself stays "route
 * and wrapper" only, per its own header; boot sequencing is a different
 * concern and belongs next to it, not inside it.
 *
 * Renders its own `<main>`, the same choice `BootError.tsx` makes and for a
 * related reason: `App`'s `<main>` does not exist yet at this point, so there
 * has to be a landmark and a skip-link target regardless of which branch below
 * is showing.
 */

import { useEffect } from 'preact/hooks';

import { App } from '@shell/App';
import { SaveNotice } from '@shell/SaveNotice';
import { bootState, startBoot } from '@shell/save';

export function Boot() {
  useEffect(startBoot, []);

  if (bootState.value.status === 'loading') {
    return (
      <main id="main" class="shell" tabIndex={-1}>
        <p>Loading your progress&hellip;</p>
      </main>
    );
  }

  const { notice } = bootState.value;
  return (
    <>
      {notice && <SaveNotice notice={notice} />}
      <App />
    </>
  );
}
